<template>
  <div>
    <div v-if='inputType === "string"'>
      {{value}}
      <span v-if='unit' class="displayValueOrvariable--unit">
        {{unit}}
      </span>
    </div>
    <div v-else-if='inputType === "number"'>
      {{formatNumber}}
      <span v-if='unit' class="displayValueOrvariable--unit">
        {{unit}}
      </span>
    </div>
    <div v-else-if='inputType === "event"' class="flex align-center justify-center">
      <div v-for='(event,i) in events' class="displayValueOrvariable--event" :key='i'>
        {{event}}
      </div>
    </div>
    <div v-else-if='inputType === "color"'>
      <div class="color-swap p-4 border border-black rounded" :style='{"background-color":value}'/>
    </div>
    <div v-else-if='inputType === "boolean"'>
      <div class="bg-white shadow w-6 h-6 p-1 flex justify-center items-center mr-2">
        <svg class="w-4 h-4 text-green-600 pointer-events-none" viewBox="0 0 172 172"><g fill="none" stroke-width="none" stroke-miterlimit="10" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode:normal"><path d="M0 172V0h172v172z"/><path d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z" fill="currentColor" stroke-width="1" :class="value ? '' : 'hidden'"/></g></svg>
      </div>
    </div>
  </div>
</template>
<script>
import { isFunction, isArray } from 'lodash';
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    const inputType = this.schema.inputType || 'string';
    const unit = this.schema.unit || '';
    return {
      inputType,
      unit
    }
  },
  computed:{
    formatNumber() {
      if (this.value && isFunction(this.value.toFixed)) {
        let formatted = this.value.toFixed(2).toString();
        return formatted.replace(/\.00$/,'')
      } else {
        return "n/a";
      }
    },
    events() {
      if (isArray(this.value)) {
        return this.value;
      } else {
        return this.value.split(",")
      }
    }
  }
}
</script>
<style>
.displayValueOrvariable--unit {
  @apply text-gray-400 leading-snug tracking-tight;
}
.displayValueOrvariable--event {
  @apply mr-2 bg-green-600 text-gray-200 rounded border-gray-700 border p-1 px-2;
}
</style>
